import { ErrorType } from "../../../models/HttpError";

// store
import * as ProtocolVisitStore from "../../../redux/middleware/ProtocolVisitsMiddleware";
import { AppState } from "../../../redux/reducers";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

interface ConnectedProps {
  isGenerating: boolean;
  isGeneratedSuccessfully: boolean;
  failOnGenerating: boolean | undefined;
  error: ErrorType | undefined;
  FileBlob: Blob | null; 
}

interface MedicalServicesDispatchProps {
  ExportProtocolVisitsToExcel: typeof ProtocolVisitStore.ActionCreators.ExportProtocolVisitsToExcel;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isGenerating: state.ProtocolVisits?.isLoading,
    isGeneratedSuccessfully: state.ProtocolVisits?.isGeneratedSuccessfully,
    failOnGenerating: state.ProtocolVisits?.failOnGenerating || false,
    error: state.ProtocolVisits?.error,
    FileBlob: state.ProtocolVisits?.excelBlob || null
});

export const mapDispatchToProps = {
  ...ProtocolVisitStore.ActionCreators
};